const smtpSeparatorComponent = {
  borderColor: {
    default: 'gray.100',
    _dark: 'gray.700'
  }
};

export default smtpSeparatorComponent;
